const amplitude = require('amplitude-js');
import {APP_ENV} from "@/common/config"

export default {
  install: (Vue, { apiKey, userId, config }) => {
    amplitude.getInstance().init(apiKey, userId, config);
	 const logEvent = (name,params)=>{
       if(APP_ENV==="production"){
          amplitude.getInstance().logEvent(name,params);
       }
       else{
          console.log(name, params);
       }
	 }
    Vue.prototype.$amplitude = {logEvent};
  },
};